import Auth from 'j-toker';
import { apiPutRequest, apiGet } from 'helpers/ApiHelper';
import {
  showSuccess as successAction,
  showFailure as failureAction,
} from 'actions/notificationActions';

const makeUrl = (token, path) => `${Auth.getApiUrl()}/landlords/vendors/${token}${path}`;

export function fetchMaintenanceTicket(token) {
  return apiGet(makeUrl(token, '/maintenance_ticket'));
}

export function updateVendorMaintenanceTicket(token, data) {
  return apiPutRequest(makeUrl(token, '/maintenance_ticket'), {
    vendor_comment: data.note,
    status: data.status,
  });
}

export function acknowledgeTicket(token) {
  return apiPutRequest(makeUrl(token, '/acknowledgement'));
}

export function showSuccess(message) {
  return (dispatch) => dispatch(successAction(message));
}

export function showFailure(message) {
  return (dispatch) => dispatch(failureAction(message));
}
